import { useEffect } from "react";
import { formatTimestamp } from "swyft-react-core";
import { ProductSubscription } from "../api/Product/ProductSubscriptionApi";
import { Quote } from "../api/Quote/Quote";
import { QuoteLineItem } from "../api/Quote/QuoteLineItem";
import { luckyOrange } from "../components/LuckyOrange";

export enum EEventType {
  AddedAddon = "Addon Added",
  AddedSubscription = "Subscription Added",
  AddonViewDetails = "Addon View Details",
  PayDepositBottom = "Pay Deposit Bottom",
  PayDepositTop = "Pay Deposit Top",
  StripeCustomerPortal = "Stripe Customer Portal",
  PageCartView = "Page Cart View",
  PageWizardAddonView = "Page Wizard Addon View",
  PageQuoteView = "Page Quote View",
  PageProtectView = "Page Boiler Servicing View",
  PagePaymentView = "Page Payment View",
  PageTermsView = "Page Terms View",
  StripeGateWayInit = "Stripe Gateway Init",
  FlexifyGateWayInit = "Flexify Gateway Init",
  StripeGateWaySuccess = "Stripe Gateway Success",
  RemovedAddon = "Addon Removed",
  RemovedSubscription = "Subscription Removed",
  PageCheckout = "Page Checkout"
}

const logConsole = function (event: string) {
  console.log(event);
};

const instanceOfQuoteLineItem = (object: any): object is QuoteLineItem => {
  return "isFixedQuantity" in object;
};

const instanceOfProductSubscription = (object: any): object is ProductSubscription => {
  return "paymentType" in object;
};

const parseEvent = (tag: string | QuoteLineItem | ProductSubscription): string => {
  if (typeof tag === "string") {
    return tag as string;
  }

  if (instanceOfQuoteLineItem(tag)) {
    eventAnalytic.record(EEventType.AddedAddon);
    const addon = tag as QuoteLineItem;
    return `Addon Added ${addon.classification}`;
  }

  if (instanceOfProductSubscription(tag)) {
    eventAnalytic.record(EEventType.AddedSubscription);
    const subscription = tag as ProductSubscription;
    return `Subscription Added ${subscription.name}`;
  }

  return "";
};

export const eventAnalytic = {
  useEffect: (tag: string) => {
    useEffect(() => {
      eventAnalytic.record(tag);
    }, [tag]);
  },
  useQuoteEffect: (quote: Quote | null) => {
    useEffect(() => {
      eventAnalytic.quote(quote);
    }, [quote]);
  },
  record: (tag: string | QuoteLineItem | ProductSubscription) => {
    let event = parseEvent(tag);

    if (event) {
      logConsole(event);
      luckyOrange.tag(event);
    }
  },
  quote: (quote: Quote | null) => {
    if (!quote) {
      return;
    }

    luckyOrange.tag(quote.type);

    luckyOrange.custom({
      quoteId: quote.name,
      name: quote.customer?.name,
      email: quote.customer?.email,
      status: quote.status,
      sent: quote.sent ? formatTimestamp(quote.sent) : null
    });
  }
};
